import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';

import { ExosLibraryComponents } from '@alexochihua/exos-library-components';
import filters from '@alexochihua/exos-functionality/dist/filters';
import '@alexochihua/exos-library-components/dist/exos-library-components.css';
import '@alexochihua/exos-library-components/dist/style.css';
import '@alexochihua/exos-library-components/dist/icon-css/style.css';
import './index.css';
import { createPinia } from 'pinia';
import VueApexCharts from 'vue3-apexcharts';
import Flip from './components/Flip.vue';
import ECustomLegend from './components/ECustomLegend.vue';

const app = createApp(App);
app.component('Flip', Flip);
app.component('ECustomLegend', ECustomLegend);
app
  .use(createPinia())
  .use(router)
  .use(filters)
  .use(i18n)
  .use(ExosLibraryComponents)
  .use(VueApexCharts)
  .mount('#app');
